<template>
  <div>
    <Button type='primary' @click="open" style="margin: 10px;">添加唤醒词</Button>
    <div>
        <Table :columns="columns" :data="awakeList" align="center"></Table>
    </div>
    <Modal  v-model="isShow"    @on-ok="submit"
    @on-cancel="cancle" >
  
    <Form ref="awake" :model="awake" :rules="ruleInline" inline  >
       <div class="formItem">
           <span class="formItem_text">唤醒词:</span>
           <FormItem prop="name">
            <Input type="text" v-model="awake.awake_word" placeholder="输入内容">
          </Input>
         </FormItem>
       </div>
        <div class="formItem">
            <span style="line-height: 30px; height: 30px; width: 50px; margin-left: 23px; white-space: nowrap;">文件：</span>
            <FormItem prop="file">
            <Upload
					:before-upload="handleUpload"
					action="//jsonplaceholder.typicode.com/posts/">
					<Button icon="ios-cloud-upload-outline"  >上传文件</Button>

				</Upload>
                <div v-if="this.awake.lib_file" style="width: 400px;  white-space:nowrap; overflow: hidden;">文件：{{ this.awake.lib_file }}</div>
				<Progress :percent="upLoadProgress" v-show="upLoadProgress_show" />
				<div v-if="file !== null">Upload file: {{ file.name }} <Button type="text" @click="doUpload" :loading="loadingStatus">{{ loadingStatus ? '上传中...' : '点击上传' }}</Button></div>
             </FormItem>
        </div>
        <div class="formItem">
            <span style="width: 100px;"> 关联用户：</span>
            <FormItem prop="tag" style="margin-left: -30px; ">
                <div class="tagList" >
                  <div v-for=" (item,index) in awakeUsers" :key="index" >
                    <Tag closable @on-close="handleClose(item,index)">{{item.mobile}}</Tag>
                  </div>
              </div>
              <Input type="text" v-model="userAwake.mobile" placeholder="请输入关键词，回车后添加" @on-enter="addAwakeUser" />
            </FormItem>
        </div>
     
    </Form>
    </Modal>  

    <Page :total="total" :current="page" :page-size="100" :show-elevator="true" @on-change="getList"/>
  </div>
</template>

<script>
const OSS = require('ali-oss');
  export   default{
    data() {
      return {
        file:null,
        isShow:false,
        upLoadProgress:0,
		    upLoadProgress_show:false,
        loadingStatus:false,
        isEdit:false,
        editItem:null,
        total:1,
        page:1,
        awakeList:[],
        awakeUsers:[],
        columns: [
                    {
                        title: '唤醒词',
                        key: 'awake_word'
                    },
                    {
                        title: '唤醒词文件',
                        key: 'file_url'
                    },
                    {
                        title: '操作',
                        key: 'handle' ,
                        render:(h, params)=>{
                           
                            return h('Button', {
                              props: { type: 'warning', size: 'small' },
				                      style: { marginRight: '5px', marginBottom: '5px'},
                              on: {
                                click: () => {
                                    this.getAwakeUsers(params.row.id);
                                    // this.editItem = params.row
                                    this.isShow = true
                                    this.isEdit = true
                                    this.awake.awake_word = params.row.awake_word
                                    this.awake.lib_file =params.row.lib_file
                                    this.awake.file_url=params.row.file_url
                                    this.awake.id=params.row.id
                                    // this.tagList = params.row.mobile.split(',')
                                }
                              }
                            },"编辑")
                        }
                    }
            ],
            awake: {
                id: 0,
                lib_file: '',
                awake_word:'',
                file_url:'',
            },
          userAwake:{
            "id":0,
            "user_id":0,
            "awake_id":0,
            "mobile":""
          },
          ruleInline: {
                name: [
                    { required: false, message: '请输入唤醒词', trigger: 'blur' }
                ],
                file: [
                { required: false, message: '请输入唤醒词', trigger: 'blur' }
                ],
                tag: [
                    { required: false, message: '请输入唤醒词', trigger: 'blur' }
                ],
        }        
      }
    },
    mounted:function(){
      this.getList(1);
    },
    methods: {
        open(){
          this.awake.id=0;
          this.awake.awake_word='';
          this.awake.lib_file='';
          this.userAwake.id=0;
          this.userAwake.mobile='';
          this.user_id=0;
          this.awakeUsers=[];
            const show =this.isShow
            this.isShow = !show
        },
        submit(){

            this.isShow =false
            this.http.post('/admin/talk/upsertAwake',this.awake).then(response=>{
                let data=response.data;
                if(data.code!==0) {
                  this.$Message.error(data.message);
                  return false;
                } else{
                  this.$Message.info(data.message);
                  this.getList(this.page) 
                  return true;
                }
            });
            
        },
        cancle(){
            console.log("取消")
            this.isShow = false
            this.awake.awake_word = ""
            this.awake.lib_file = ""
            this.awake.id = 0
            this.tagList = []
            this.isShow = false
            this.upLoadProgress = 0
            this.upLoadProgress_show = false
            this.loadingStatus = false
            this.file = null
        },
        handleUpload (file) {
	        this.file = file;
	        return false;
	      },
        doUpload() {
          this.http.get('/admin/material/getUpoadVideoToken').then(response=>{
          let data=response.data;
          console.log(data);
          if(data.StatusCode!=200){
            this.$Message.error(data.message);
          } else {
            const config = data;
            console.log(config);
      
            const ossClient = new OSS({
              accessKeyId: config.AccessKeyId,
              accessKeySecret: config.AccessKeySecret,
              stsToken: config.SecurityToken,
              bucket:config.bucket,
              region:config.RegionId,
              secure:true,
              endpoint:'oss-cn-zhangjiakou.aliyuncs.com'
            });
				
            const fileName = Date.now()+'-'+this.file.name;  
            //const fileName = '风平IP智造'+this.app.app_version+'.exe'
            
            const progress = (p, _checkpoint) => {
              // Object的上传进度。
              this.upLoadProgress_show = true;
              this.upLoadProgress = parseInt(p*100);
              //console.log(p); 
              // 分片上传的断点信息。
              //console.log(_checkpoint); 
            };
				 
            ossClient.multipartUpload('freefishpc/awake_lib/'+fileName, this.file,{progress}).then(
              result => {     
                this.awake.lib_file='freefishpc/awake_lib/'+fileName;
                console.log(`Common upload ${fileName} succeeded, result === `, result)   
                            // this.formInline.file= result.name

              }).catch(
                err => {     
                  console.log(`Common upload ${fileName} failed === `, err);   
              }); 
            }
            }).catch(()=>{
              this.$Message.error('网络错误');
            });
	      },
        handleClose(item,index){
          this.http.post('/admin/talk/delAwakeUser',{"user_id": item.user_id,"awake_id": this.awake.id}).then(response=>{
          // let data=response.data;
          this.awakeUsers.splice(index, 1);
        }).catch((e)=>{
          console.log(e);
          this.$Message.error('网络错误');

        });
         
				
        },
        addAwakeUser(){
          this.http.get('/admin/user/userList',{params:{'mobile':this.userAwake.mobile}}).then(response=>{
            let data=response.data;
            if(data.code!==0){
            alert(data.message);
            } 
            else
            {
              var uitem=null;
              for(var k in data.data.list)
              {
                
                 if(data.data.list[k].account_type==0)
                 {
                    uitem=data.data.list[k];
                    break;
                 }
              }
              console.log(uitem);
              if(!uitem)
              {
                alert("用户不存在");
                return;
              }
              this.userAwake.awake_id=this.awakeId;
              this.userAwake.user_id=uitem.id;
              console.log(this.userAwake);
              this.http.post('/admin/talk/addAwakeUser',{'awake_id':this.awakeId,"user_id":uitem.id}).then(response=>{
                      let data=response.data;
                      if(data.code!==0){
                      alert(data.message);
                      } else{
                      this.userAwake.id=data.data;
                      this.awakeUsers.push(this.userAwake);
                      }
                    }).catch((e)=>{
                      console.log(e);
                      this.$Message.error('网络错误');
              });
            
            }
          }).catch(()=>{
                this.$Message.error('网络错误');
          });
        },
        getAwakeUsers(awakeId){
          this.http.get('/admin/talk/getUserByAwake',{params:{'awake_id':awakeId}}).then(response=>{
            this.awakeId=awakeId;
            let data=response.data;
            if(data.code!==0){
            alert(data.message);
            } else{
            this.awakeUsers = data.data;
            console.log(this.awakeUsers);
            }
          }).catch(()=>{
            this.$Message.error('网络错误');
          });
        }, 
        getList(page) {
          this.http.get('/admin/talk/awakeList',{params:{'page':page}}).then(response=>{
            let data=response.data;
            if(data.code!==0){
            alert(data.message);
            } else{
            this.awakeList = data.data.list;
            this.total=data.data.total;
            }
          }).catch(()=>{
            this.$Message.error('网络错误');
          });
        },
    }    

  }
  
</script>

<style  scoped>
/deep/ .ivu-table-wrapper{
    position: relative;
    overflow: hidden;
    min-height: 660px;
}


.formItem{
   
    display: flex;
  
   
}
.formItem_text{
    margin-left: 25px;
    margin-right: 5px;
    height: 30px;
    line-height: 30px;
}
.tagList{
    display: flex;
    max-width: 500px;
    flex-wrap: wrap;
    white-space: normal;
}
 /deep/ .ivu-input{
    width: 200px;
}
/deep/ .ivu-table-header thead tr th{
    
    text-align: center;
}

/deep/ .ivu-table-cell{
    text-align: center;
}

</style>